import React from "react";
import styles from "./collapsed_data_list.module.css";
import { USER_ROLES } from "../../utils/constants";

const FirmData = ({ firm, customer }) => {

  return (

    <div className={styles.data_list}>
      {
        firm && Object.entries(firm).length > 0 ?
          <>
            <div className={styles.item_container}>
              <p className={styles.name_data}>Название: </p>
              <div className={styles.value_data}>{firm.name}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>Сокращённое название: </p>
              <div className={styles.value_data}>{firm.short_name}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>ИНН: </p>
              <div className={styles.value_data}>{firm.inn}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>КПП: </p>
              <div className={styles.value_data}>{firm.kpp}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>ОГРН: </p>
              <div className={styles.value_data}>{firm.ogrn}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>Адрес: </p>
              <div className={styles.value_data}>{firm.adress}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>Расчётный счёт: </p>
              <div className={styles.value_data}>{firm.rass_schet}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>Банк: </p>
              <div className={styles.value_data}>{firm.bank_name}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>БИК банка: </p>
              <div className={styles.value_data}>{firm.bik}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>Корреспонденский счёт: </p>
              <div className={styles.value_data}>{firm.korr_schet}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>{firm.director_post}: </p>
              <div className={styles.value_data}>{firm.director_name}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>На основании: </p>
              <div className={styles.value_data}>{firm.director_footing}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>Email: </p>
              <div className={styles.value_data}>{firm.email}</div>
            </div>
            {[USER_ROLES.superuser, USER_ROLES.manager, USER_ROLES.buhgalter].includes(customer.role) &&
              (<div className={styles.item_container}>
                <p className={styles.name_data}>Отсрочка оплаты: </p>
                <div className={styles.value_data}>{firm.default_def_payment}</div>
              </div>)
            }
          </> :
          <>
            <div className={styles.item_container}>
              <p className={styles.name_data}>Фамилия: </p>
              <div className={styles.value_data}>{customer.last_name}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>Имя: </p>
              <div className={styles.value_data}>{customer.first_name}</div>
            </div>
            <div className={styles.item_container}>
              <p className={styles.name_data}>Отчество: </p>
              <div className={styles.value_data}>{customer.surname}</div>
            </div>
          </>
      }
    </div>
  )
}

export default FirmData;
